import React, { useCallback, useEffect, useState } from "react";
import { columnsUsers } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { getWebUsersList, updateUserSubscriptionStatus } from "../../Redux/Actions/usersActions";
// import TableComponent from "../../Global Functions/tableComponents";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const WebUsers = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { webUsersList, loading } = useSelector(
    (state) => state.users
  );


  const fetchUsers = useCallback(async (page, pageSize, showLoader = true) => {
    const userData = {
      page,
      limit: pageSize,
      is_deleted: false,
      filter: debouncedSearch,
      signup_from: "web",
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(getWebUsersList(userData, showLoader));

      if (!showLoader) {
        toast.success("Web users list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh web users list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  )

  // useEffect(() => {
  //   setPagination((prev) => ({ ...prev, current: 1 }));
  //   fetchUsers(1, pagination.pageSize);
  // }, [debouncedSearch]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);


  const handleSubscriptionToggle = async (userId, subscribe) => {
    try {
      const result = await dispatch(updateUserSubscriptionStatus({
        user_ids: [userId],
        email_subscribe: subscribe
      }));

      if (result) {
        toast.success(result.message || `${subscribe ? 'Subscribed' : 'Unsubscribed'} successfully`);
        fetchUsers(pagination.current, pagination.pageSize, false);
      }
    } catch (error) {
      toast.error("Failed to update subscription status");
    }
  };

  useEffect(() => {
    fetchUsers(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchUsers]);


  useEffect(() => {
    if (webUsersList?.total) {
      setPagination((prev) => ({ ...prev, total: webUsersList.total }));
    }
  }, [webUsersList]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleDownloadUsersExcel = async () => {
    try {
      const data = {
        page: pagination.current,
        limit: pagination.pageSize,
        filter: debouncedSearch,
        signup_from: "web",
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
        is_deleted: false,
      };

      const userData = await dispatch(
        getWebUsersList(data)
      );

      const rawUserData = userData?.data || [];
      if (!Array.isArray(rawUserData) || rawUserData.length === 0) {
        alert("No user data available to download");
        return;
      }

      const preparedData = rawUserData.map((user) => ({
        _id: user._id,
        name: user.name,
        user_id: user.user_id,
        country_code: user.country_code,
        country_name: user.country?.country_name || "",
        contact_number: user.contact_number,
        refer_from: user.refer_from || "",
        created_at: user.created_at,
        email: user.email || "",
      }));
      const worksheet = XLSX.utils.json_to_sheet(preparedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
      XLSX.writeFile(workbook, "users_data.xlsx");
    } catch (error) {
      alert("Failed to download user data");
    }
  };

  const userColumns = columnsUsers(pagination.current, pagination.pageSize, handleSubscriptionToggle);

  return (
    <>
      <TableComponentsCp
        h3heading="Web Users List"
        onDownload={handleDownloadUsersExcel}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        setState={setSearchQuery}
        pagination={pagination}
        onChange={handleTableChange}
        columns={userColumns}
        dataSource={(Array.isArray(webUsersList?.data) && webUsersList.data) || []}
        loading={loading}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default WebUsers;
